import { render, staticRenderFns } from "./AlarmPage.vue?vue&type=template&id=34aea4f6&scoped=true&"
import script from "./AlarmPage.vue?vue&type=script&lang=js&"
export * from "./AlarmPage.vue?vue&type=script&lang=js&"
import style0 from "./AlarmPage.vue?vue&type=style&index=0&id=34aea4f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aea4f6",
  null
  
)

export default component.exports